import React, { ReactNode } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

import { Icons } from "../../data/Assets";

import useSignOut from "../../hooks/auth/useSignOut";

import { openModal } from "../../store/slices/modal";

import SchoolsTree from "../sub_components/SchoolsTree";
import { SVGIcon } from "../wrappers/SVGIcon";

import { ISchoolsTreeProps } from "../../interfaces/tree";

interface IMainLayoutProps {
    children: ReactNode;
    schoolsData?: ISchoolsTreeProps;
};
const MainLayout = (props: IMainLayoutProps) => {
    const { children, schoolsData } = props;

    const dispatch = useDispatch();

    const { mutate: signOut } = useSignOut();

    const openLogoutModal = () => {
        dispatch(openModal({
            name: 'MESSAGE_MODAL',
            data: {
                view: 'CONFIRMATION',
                closeBtn: false,
                title: "Confirm sign out?",
                content: "Do you want to sign out of your account?",
                actionTxt: "Sign out",
                action: () => signOut(),
            }
        }))
    };

    return (
        <div className="immersion_admin__main_layout">
            <div className="immersion_admin__main_layout__top">
                <h4 className="color_dark">Immersion Admin</h4>
                <button onClick={openLogoutModal}>
                    <SVGIcon src={Icons.LogOff} />
                    <span>Sign out</span>
                </button>
            </div>
            <div className="immersion_admin__main_layout__menu">
                <NavLink
                    to={'/schools'}
                    className={({ isActive }) => `immersion_admin__main_layout__menu__link ${isActive ? 'immersion_admin__main_layout__menu__link__active' : ''}`}
                >
                    Schools
                </NavLink>
                <NavLink
                    to={'/reports/user-sign-up'}
                    className={({ isActive }) => `immersion_admin__main_layout__menu__link ${isActive ? 'immersion_admin__main_layout__menu__link__active' : ''}`}
                >
                    Reports
                </NavLink>
            </div>
            <div className="immersion_admin__main_layout__content">
                <div className="immersion_admin__main_layout__content__left">
                    {!!schoolsData &&
                        <SchoolsTree
                            schools={schoolsData.schools}
                            selected={schoolsData.selected}
                            setSelected={schoolsData.setSelected}
                            expanded={schoolsData.expanded}
                            setExpanded={schoolsData.setExpanded}
                        />
                    }
                </div>
                <div className="immersion_admin__main_layout__content__right">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MainLayout;